<p-toolbar class="!h-[72px] shadow header-gradient">
  <ng-template #start>
    <div class="flex items-center h-full gap-3">
      <div class="relative w-[148px] h-[56px]">
        <img alt="Logo Artesp" class="object-contain cursor-pointer" fill loading="lazy"
             routerLink="/" ngSrc="./assets/images/artesp_logo_black_red.png"/>
      </div>
      <p-divider layout="vertical"/>
      <div class="relative w-[120px] h-[56px]">
        <img alt="Logo Sisnot" routerLink="/" class="object-contain cursor-pointer"
             fill ngSrc="./assets/images/sisnot_logo.png" priority/>
      </div>
    </div>
  </ng-template>

  <ng-template #end>
    <div class="flex items-center gap-3 pr-2">
      <p-button
        [icon]="isDark ? 'pi pi-sun' : 'pi pi-moon'"
        [pTooltip]="isDark ? 'Tema claro' : 'Tema escuro'"
        (onClick)="toggleTheme()"
        [rounded]="true"
        [text]="true"
        severity="secondary"
      />
      <p-divider layout="vertical"/>
      @if (authenticated && user) {
        <div class="flex gap-3 items-center">
          @if (sei.liberado()) {
            <app-sei-status/>
          }
          <span class="text-white text-sm">{{ user!.name }}</span>
          <p-avatar [label]="initials"
                    [style]="{'background-color': '#E41B2E', color: '#ffffff'}"
                    shape="circle" size="normal"/>
          <p-button
            icon="pi pi-sign-out"
            pTooltip="Sair"
            (onClick)="logout()"
            [rounded]="true"
            [text]="true"
            severity="secondary"
          />
        </div>
      } @else {
        <p-button label="Entrar" icon="pi pi-sign-in" (onClick)="login()" size="small"/>
      }
      <p-divider layout="vertical"/>
      <span class="text-xs text-gray-300 pr-1">v{{ version }}</span>
    </div>
  </ng-template>
</p-toolbar>
